import { TableCell } from '@mui/material';

export default function MemberContactCell({ row }) {
  const { email, telegram } = row;
  return (
    <TableCell>
      <p>
        <a className="dashed-btn" href={`mailto:${email}`}>
          {email}
        </a>
      </p>
      {telegram && (
        <p>
          <a
            className="dashed-btn"
            href={`https://t.me/${telegram}`}
            target="_blank"
            rel="noreferrer"
          >
            @{telegram}
          </a>
        </p>
      )}
    </TableCell>
  );
}
